import { CloseOutlined, SwapRightOutlined } from '@ant-design/icons';
import { Button, Card, Stack } from 'shared';
import React from 'react';
import { SensorLabel } from './SensorLabel';
import { DatePicker } from 'antd';
import { SentryApiClient } from '_generated/api';
import moment from 'moment';
import dayjs from 'dayjs';

interface ComparisonCardProps {
  sensor: SentryApiClient.SensorDTO;
  timespan: number;
  start: moment.Moment | null;
  onChange?: (start: moment.Moment | null) => void;
  onRemove?: () => void;
}

export const ComparisonCard: React.FC<ComparisonCardProps> = ({
  sensor,
  timespan,
  start,
  onRemove,
  onChange,
}) => {
  const end = start?.clone().add(timespan, 'millisecond');

  const sensorName = sensor.sensorName ?? 'Sensor';

  return (
    <Card
      role="region"
      aria-label={`Comparison: ${sensorName}`}
      title={
        <Stack alignment="middle" gap="apart">
          <SensorLabel sensor={sensor} />

          <Button
            type="text"
            icon={<CloseOutlined />}
            aria-label={`Remove ${sensorName}`}
            onClick={onRemove}
          />
        </Stack>
      }
    >
      <Stack>
        <Stack gap="sm" alignment="middle">
          <DatePicker
            showTime
            format="YYYY-MM-DD HH:mm"
            value={start ? dayjs(start.toDate()) : null}
            onChange={(value) =>
              onChange && onChange(value ? moment(value.toDate()) : null)
            }
            aria-label="Comparison start date"
          />
          <SwapRightOutlined aria-hidden={true} />
          <DatePicker
            showTime
            format="YYYY-MM-DD HH:mm"
            value={end ? dayjs(end.toDate()) : null}
            onChange={(value) =>
              onChange &&
              onChange(value ? moment(value.toDate()).subtract(timespan) : null)
            }
            aria-label="Comparison end date"
          />
        </Stack>
      </Stack>
    </Card>
  );
};
